import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';

// elvispos
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';
import { ThemeService } from 'ngx-elvis-ds';
import { BasePage, Helpers } from 'ngx-elvis-ds';
import { ScanditService } from 'src/app/services/scandit.service';

export class CameraDialogCommands {
  public static OPEN = ['INFO_DIALOG_OPEN'];
  public static UPDATE = ['INFO_DIALOG_UPDATE'];
  public static CLOSE = ['INFO_DIALOG_CLOSE'];
}

@Component({
  selector: 'app-camera-dialog',
  templateUrl: './camera-dialog.page.html',
  styleUrls: ['./camera-dialog.page.scss'],
})
export class CameraDialogPage extends BasePage implements AfterViewInit {

  constructor(
    public themeSvc: ThemeService,
    private sam: SAMService,
    private configSvc: ConfigService,
    private modalCtrl: ModalController,
    public scanditSvc: ScanditService,
  ) {
    super();
  }

  async ngAfterViewInit() {
    await this.scanditSvc.onInit();
    this.scanditSvc.setScanMode(true);
  }

  onCallback() {
    this.scanditSvc.setScanMode(false);
    this.modalCtrl.dismiss();
  }

  // private
}
